<ngx-loading [show]="loading"></ngx-loading>

<div class="modal-header">
  <h2 class="d-block text-center w-100" id="modal-basic-title">
    {{task?.id ? 'Update' : 'New'}} Task
  </h2>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-header d-flex flex-row-reverse">
  <mat-button-toggle-group class="view-selector pull-right" name="selectedView" appearance="legacy"
                           [ngModelOptions]="{standalone: true}"
                           [(ngModel)]="selectedFormView"
                           [disabled]="!task?.id">
    <mat-button-toggle value="task">Task Details</mat-button-toggle>
    <mat-button-toggle value="notifications">Notifications</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<form (ngSubmit)="save()" [formGroup]="taskForm" *ngIf="selectedFormView === 'task'">
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <mat-form-field>
          <input placeholder="Name *" maxlength="100" formControlName="name" matInput/>
        </mat-form-field>
        <mat-form-field [matTooltip]="'Examples: Application Form, Contract, Certificate of Insurance'">
          <input placeholder="Correlated resource or action *" maxlength="35" formControlName="entity_name" matInput/>
        </mat-form-field>
        <mat-form-field>
          <input placeholder="Order *" type="number" min="0" [max]="maxIndex" formControlName="order" matInput/>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Intended for (who is meant to complete the task) *" formControlName="intended_for_role" (selectionChange)="selectIntendedForRole($event)">
            <mat-option *ngFor="let role of roles" [value]="role.name">
              {{ role.description }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field>
          <mat-select placeholder="Type *" formControlName="task_type_id"
                      (selectionChange)="selectTaskType($event)">
            <mat-option *ngFor="let taskType of taskTypes" [value]="taskType.id" [disabled]="!taskType.entity_data_value_type">
              {{ taskType.name }} ({{ taskType.entity_data_value_type }})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="Responsible (optional)" formControlName="default_responsible_id"
                      (selectionChange)="selectUser($event)">
            <mat-option [value]="null">None (set automatically to primary contact)</mat-option>
            <mat-option *ngFor="let user of users" [value]="user.id">
              {{ user.first_name }} {{ user.last_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="Depends on task (optional)" formControlName="depends_on_task"
                      (selectionChange)="selectTaskDependency($event)">
            <mat-option [value]="null" [disabled]="!!selectedTaskForApproval">None</mat-option>
            <mat-option *ngFor="let t of tasks" [value]="t.id" [disabled]="t.id === task?.id || (selectedTaskForApproval && t.id !== selectedTaskForApproval.id)">
              [{{ t.order }}] {{ t.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="selectedTaskType?.interaction_type === 'approve'">
          <mat-select placeholder="Approves task *" formControlName="affected_task"
                      (selectionChange)="selectTaskForApproval($event)">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let t of tasks" [value]="t.id" [disabled]="t.id === task?.id">
              [{{ t.order }}] {{ t.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-slide-toggle
          align="right"
          color="primary"
          formControlName="is_enabled"
          [matTooltip]="'Disabled tasks will not be visible on the timeline for non-admin users.'"
        >
          Enabled
        </mat-slide-toggle>
        <mat-slide-toggle
          align="right"
          color="primary"
          formControlName="allow_anyone_to_complete"
        >
          Allow anyone to complete
        </mat-slide-toggle>
      </div>
    </div>

    <div class="row my-4">
      <div class="col-md-12">
        <!-- <mat-form-field>
            <textarea placeholder="Description *"
                      rows="6" formControlName="description" matInput></textarea>
        </mat-form-field> -->
        <ngx-title-divider title="Description"></ngx-title-divider>
        <md-editor name="description" 
          formControlName="description"
          [(ngModel)]="taskDescription" 
          [height]="'300px'" 
          [options]="{showPreviewPanel: false, resizable: true}"
          required>
        </md-editor>
      </div>
    </div>

    

    <div formGroupName="due_date_meta">

      <div class="row my-4">
        <div class="col-md-8">
          <ngx-title-divider title="Due date settings" [bold]="true"></ngx-title-divider>
        </div>

        <div class="col-md-4">
          <mat-form-field>
            <mat-select placeholder="" formControlName="date_meta_type"
                        (selectionChange)="selectDateMetaType($event)">
              <mat-option *ngFor="let type of dateMetaTypes" [value]="type.key">
                {{type.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="selectedDateMetaType === 'specific'">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="specificDatePicker"
              placeholder="Date *"
              formControlName="specific_date"
              (click)="specificDatePicker.open()"
              readonly
            />
              <!-- [min]="poInfoForm.controls.order_date.value" -->
            <mat-datepicker-toggle matSuffix [for]="specificDatePicker"></mat-datepicker-toggle>
            <mat-datepicker
              #specificDatePicker
              title="Pick any date"
            ></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="selectedDateMetaType === 'relative'">
        <div class="col-md-3">
          <mat-form-field>
            <input placeholder="Amount" [min]="0" formControlName="number" type="number" matInput/>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field>
            <mat-select placeholder="Period" formControlName="period">
              <mat-option *ngFor="let period of periods" [value]="period.key">
                {{period.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field>
            <mat-select placeholder="Before/After" formControlName="before_after">
              <mat-option value="before">
                Before
              </mat-option>
              <mat-option value="after">
                After
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field >
            <mat-select placeholder="Resource type" formControlName="resource"
                        (selectionChange)="selectResource($event)">
              <mat-option *ngFor="let resource of validResourceDateFields" [value]="resource.resource_name">
                {{resource.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="selectedResource?.resource_name === 'task'">
          <mat-form-field>
            <mat-select placeholder="{{ tasks.length ? 'Select a Task' : 'No tasks available'}}" formControlName="resource_id">
              <mat-option *ngFor="let t of tasks" [value]="t.id" [disabled]="t.id === task?.id">
                [{{ t.order }}] {{ t.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-5" *ngIf="selectedResource">
          <mat-form-field >
            <mat-select placeholder="Date field" formControlName="resource_date_field">
              <mat-option *ngFor="let field of selectedResource.fields" [value]="field.field_name">
                {{field.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>
    </div>

    <div>
      <div class="row my-4">
        <div class="col-md-12">
          <ngx-title-divider title="Attachments" [bold]="true"></ngx-title-divider>
          <!-- <ngx-attachments
            #files
            *ngIf="this.task?.id"
            [isApprovalSection]="false"
            [enableControls]="!!this.task?.id"
            [purchaseOrderId]="this.task?.id"
            [companyType]="'customer'"
            [defaultTag]="'$task_definition'"
          ></ngx-attachments> -->
          <span *ngIf="!this.task?.id">
            Please save the task before adding attachments.
          </span>
            <!-- [addFileEventEmitter]="addSubmittedDocumentFileEventEmitter" -->
        </div>
      </div>
    </div>
  </div>
    
  <div class="modal-footer">
    <button class="btn btn-primary"
            [disabled]="taskForm.invalid">
            Save
    </button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
  </div>

</form>

<form (ngSubmit)="saveNotifications()" [formGroup]="notificationsForm" *ngIf="selectedFormView === 'notifications'">
  <div class="modal-body">
    
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary"
            [disabled]="notificationsForm.invalid">
            Save
    </button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
  </div>
</form>